// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface ProfileManageDataPageTelemetryObjects {
    clearData: TelemetryObjectBase;
    clearDataConfirmation: TelemetryObjectBase;
    step0CancelBtn: TelemetryObjectBase;
    step0RemoveDataBtn: TelemetryObjectBase;
    step1YesRemoveDataBtn: TelemetryObjectBase;
    step1CancelDataBtn: TelemetryObjectBase;

}

export const profileManageDataPageTelemetryContracts = {
    /** Profile Privacy > Scenario 3a */
    clearData: {
        name: "ClearMyData",
        content: {
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Privacy > Scenario 3c */
    clearDataConfirmation: {
        name: "ClearDataConfirmation",
        content: {
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Privacy > Scenario 3b cancel
     * id: traceId
    */
    step0CancelBtn: {
        name: "Cancel",
        behavior: TelemetryBehaviorType.Cancel,
        content: {
            headline: "Cancel",
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Privacy > Scenario 3b removedata
     * id: traceId
    */
    step0RemoveDataBtn: {
        name: "RemoveData",
        behavior: TelemetryBehaviorType.Cancel,
        content: {
            headline: "Remove Data",
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Privacy > Scenario 3d user clicks yes remove data
     * id: traceId
    */
    step1YesRemoveDataBtn: {
        name: "RemoveDataConfirmation",
        behavior: TelemetryBehaviorType.Cancel,
        content: {
            headline: "Yes Remove It",
            type: TelemetryContentType.Profile
        }
    },
    /** Profile Privacy > Scenario 3d user clicks cancel
 * id: traceId
*/
    step1CancelDataBtn: {
        name: "Cancel",
        behavior: TelemetryBehaviorType.Cancel,
        content: {
            headline: "Cancel",
            type: TelemetryContentType.Profile
        }
    }

};